import * as Yup from 'yup';

export const roleFormValidationSchema = Yup.object({
  name: Yup.string().required('Role name is required.'),
});
